import React, { useState } from "react";
import NavBar from "../Components/NavBar";
import Mailbox from "./Mailbox";
import "../assets/Send.css";

export const Send = (props) => {
  const [form, setForm] = useState(true);
  const [sender, setSender] = useState("");
  const [receiver, setReceiver] = useState("");

  function toggleForm() {
    if (form) {
      setForm(false);
    } else {
      setForm(true);
    }
  }

  const toggleSender = (e) => {
    setSender(e.target.value);
  };

  const toggleReceiver = (e) => {
    setReceiver(e.target.value);
  };

  if (form) {
    return (
      <div className="letter">
        <NavBar />
        <div className="info">
          <h6 style={{ marginBottom: "20px" }}>
            To:{" "}
            <input
              type="text"
              className="fields"
              value={receiver}
              onChange={toggleReceiver}
            />
          </h6>
          <h6 style={{ marginBottom: "20px" }}>
            From:{" "}
            <input
              type="text"
              className="fields"
              value={sender}
              onChange={toggleSender}
            />
          </h6>
          <h6 style={{ marginBottom: "20px" }}>
            Other Info:{" "}
            <textarea placeholder="" rows="7" cols="50" className="fields" />
          </h6>
          <button
            className="button"
            onClick={toggleForm}
            style={{ marginRight: "10px" }}
          >
            Submit
          </button>
          <a className="button" href="/Draft">
            Edit ✏️
          </a>
        </div>
      </div>
    );
  } else {
    return <Mailbox text={props.text} sender={sender} receiver={receiver} />;
  }
};

export default Send;
